/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BRAND_NAME,BRAND_DESC, BRAND_NAME_ERROR, BRAND_NAME_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
import { TextField } from '@mui/material';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';
import { useSelector } from 'react-redux';
import type { RootState, BrandFormInputs, BrandApiResponse } from '../types/types';
import { addBrand } from 'src/services/brandService';


interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

const validationSchema = Yup.object().shape({
    brandName: Yup.string().required(BRAND_NAME_ERROR).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, BRAND_NAME_INVALID),
    brandDescription: Yup.string().nullable().matches(/^\S.*\S$|^\S$/, "Please enter a valid brand description"),
});

function AddBrandForm({closeModal, refreshPage}: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);

    
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<BrandFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
        defaultValues: {
            brandDescription: null
        },
    });
    
    const onSubmit = async (data: BrandFormInputs): Promise<void> => {
        data.createdBy =  user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;
        data.brandDescription = data.brandDescription == "" ? null : data.brandDescription;
        setIsLoading(true)
        await addBrand(data)
            .then(
                (res: BrandApiResponse) => {
                    console.log(res)
                    if(res.status === 200) {
                        if(res.data.result === 1) {
                            
                            NotificationManager.success("Brand added successfully")
                            refreshPage()
                        } else if (res.data.messages === 'Campaign Brand was not added.') {
                            NotificationManager.error('Brand already exists');
                        } 
                        else {
                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            NotificationManager.error("Unknown error has occurred");
                        }  
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                console.log("done")
                setIsLoading(false)
            })
    }

    return (
        <React.Fragment>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className="relative px-[16px] pt-[10px]">
                    <div className="mb-[30px]">
                        <Controller
                            name="brandName"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Brand Name*"
                                autoComplete="off"
                                InputProps={{
                                    inputProps: {
                                    style: {
                                        textAlign: "left",
                                        color: '#343434',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        WebkitTextFillColor: '#343434',
                                        padding: '9px 14px',
                                    },
                                    placeholder: `${BRAND_NAME}`,
                                    },
                                }}
                                sx={{
                                    "& label": {
                                    textAlign: "center",
                                    },
                                    backgroundColor: "#F5F5F5",
                                }}
                                error={!!errors.brandName} // Set error state based on form validation
                                placeholder={BRAND_NAME}
                                />
                                {errors.brandName && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.brandName?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="brandDescription"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Description"
                                autoComplete="off"
                                InputProps={{
                                    inputProps: {
                                    style: {
                                        textAlign: "left",
                                        color: '#343434',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        WebkitTextFillColor: '#343434',
                                        padding: '9px 14px',
                                    },
                                    placeholder: `${BRAND_DESC}`,
                                    },
                                }}
                                sx={{
                                    "& label": {
                                    textAlign: "center",
                                    },
                                    backgroundColor: "#F5F5F5",
                                }}
                                error={!!errors.brandDescription} // Set error state based on form validation
                                placeholder={BRAND_DESC}
                                />
                                {errors.brandDescription && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.brandDescription?.message} 
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                    <div className="w-full relative col-span-3">
                        <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                    </div>
                    <div className="w-full relative col-span-3">
                        <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]">{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                    </div>
                </div>
            </form>


        </React.Fragment>
    )
}

export default AddBrandForm